module.exports = __webpack_public_path__ + "img/f2.e6cce8fa.jpg";